<template>
  <div class="calendar-cards-tooltip">
    <CalendarCardItem
      v-for="(card, index) in cardList"
      :key="index"
      :card="card"
      @open-card="openCard"
    />
  </div>
</template>

<script setup lang="ts">
import CalendarCardItem from '../CalendarCardItem.vue';

defineProps({
  cardList: {
    type: Array<any>,
    required: true,
  },
});

const emit = defineEmits(['close-tippy']);

const openCard = () => {
  emit('close-tippy');
};
</script>

<style lang="scss">
.calendar-cards-tooltip {
  @apply flex flex-col gap-1 bg-background-strongest py-[7px] border border-solid border-standard-border rounded shadow-default-tooltip;
}
</style>
